<template>
  <div>
    <quiz-see-more
      icon="mdi-information-outline"
      :small="small"
      :short-text="$t('live.examOnboarding.instructions.title')"
      :learn-more="$t('live.examOnboarding.instructions.learnMore')"
      :see-less="$t('live.examOnboarding.instructions.seeLess')"
      :text="examRulesStudentInfo"
    />
    <quiz-see-more
      icon="mdi-numeric-1-box-multiple-outline"
      :small="small"
      :short-text="$t('live.examOnboarding.grade.title')"
      :learn-more="$t('live.examOnboarding.grade.learnMore')"
      :see-less="$t('live.examOnboarding.grade.seeLess')"
      :text="gradingStudentInfo"
    />
  </div>
</template>

<script>
import QuizSeeMore from "./quiz_see_more.vue"
import { useQuizSummary } from "@/composables/useQuizSummary"
import { toRefs } from "vue"

export default {
  name: "QuizGradingInfo",
  components: { QuizSeeMore },
  props: {
    quiz: {
      type: Object,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { quiz } = toRefs(props)
    const { gradingStudentInfo, examRulesStudentInfo } = useQuizSummary({ quiz: quiz.value })
    return {
      gradingStudentInfo,
      examRulesStudentInfo,
    }
  },
}
</script>

<style scoped>

</style>
